<template>
  <div class="uk-width-1-2@s">
    <div class="uk-card uk-card-large uk-card-default uk-card-hover">
      <div class="uk-card-header">
        <div
          class="uk-grid-small uk-flex-middle"
          uk-grid
        >
          <div class="uk-width-expand">
            <h3 class="uk-margin-top uk-card-title uk-margin-remove-bottom">
              <slot name="title">
                Title
              </slot>
            </h3>
            <p class="uk-text-meta uk-margin-remove-top">
              <time :datetime="dateTimeHtml">
                <slot name="date">
                  April 01, 2016
                </slot>
              </time>
            </p>
          </div>
        </div>
      </div>
      <div class="uk-card-media-top">
        <img
          width="auto"
          :data-src="imageSource"
          :alt="altText"
          uk-img
        >
      </div>
      <div class="uk-card-body uk-text-left uk-padding-remove-bottom uk-margin-medium-bottom uk-padding-remove-top uk-margin-small-top">
        <slot name="preview">
          Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo.
        </slot>
        <span class="uk-card-badge uk-label uk-inline uk-position-top-right uk-margin-small">
          <slot name="badge">
            Badge
          </slot>
        </span>
      </div>
      <div class="uk-card-footer">
        <router-link
          class="uk-button uk-button-text"
          :to="postUrl"
        >
          Read more
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dateTimeHtml: {
      type: String,
      required: true
    },
    imageSource: {
      type: String,
      required: true
    },
    altText: {
      type: String,
      required: true
    },
    postUrl: {
      type: String,
      required: true
    }
  }
}
</script>

<style>

</style>
